import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { TechTuningCategory, TechTuningSection } from '~/shared';
import { CategoryImages } from '../CategoryTab/CategoryTab.model';
import {
	handlingIcons,
	techTuningSectionNameGenitive,
} from '../SettingsTab/SettingsTab.model';
import {
	StyledButtonContainer,
	StyledButtonContent,
	StyledContainer,
	StyledGlow,
	StyledInfo,
} from './SectionLock.styled';

interface ISectionLockProps {
	section: TechTuningSection;
	requiredCategory: TechTuningCategory | null;
	onBuy: (category: TechTuningCategory) => void;
}

const SectionLock: React.FC<ISectionLockProps> = ({
	section,
	requiredCategory,
	onBuy,
}) => {
	const icon =
		(requiredCategory && CategoryImages[requiredCategory]) ||
		handlingIcons[section];

	return (
		<StyledContainer>
			<StyledGlow />
			<StyledInfo>
				<ImgIcon icon={icon} width={30} height={30} />
				<Text>
					{`Вы не можете изменить параметры ${techTuningSectionNameGenitive[section]}, так как у вас не установлена регулируемая запчасть.\n\nПриобрести нужную вам запчасть вы сможете в магазине.`}
				</Text>
			</StyledInfo>
			{requiredCategory && (
				<StyledButtonContainer>
					<Button
						color={ButtonColors.Buy}
						height={ButtonHeight.Height50}
						borderRadius={ButtonBorderRadius.Radius5}
						style={{ fontSize: 16 }}
						onClick={() => onBuy(requiredCategory)}
					>
						<StyledButtonContent>
							<ImgIcon icon={icon} width={20} height={20} />
							<Text>Купить деталь</Text>
						</StyledButtonContent>
					</Button>
				</StyledButtonContainer>
			)}
		</StyledContainer>
	);
};

export { SectionLock };
